export default __webpack_public_path__ + "static/media/pepperoni.54447434.png";